import { render, staticRenderFns } from "./VeJwCjChangeXsList.vue?vue&type=template&id=5961b9c0&scoped=true"
import script from "./VeJwCjChangeXsList.vue?vue&type=script&lang=js"
export * from "./VeJwCjChangeXsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5961b9c0",
  null
  
)

export default component.exports